<template>
  <footer class="footer">
    <div class="ec-container">
      <div class="footer__top">
        <div class="footer__brand">
          <a href="#home" class="brand">
            <span class="brand__mark" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="28" height="28">
                <defs>
                  <linearGradient id="footGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#FF9900" /><stop offset="0.5" stop-color="#FFB84D" /><stop offset="1" stop-color="#FF6F00" />
                  </linearGradient>
                </defs>
                <path fill="url(#footGrad)" d="M23 13.2A8 8 0 0 0 7.6 12 6 6 0 0 0 8 24h14.5a5.5 5.5 0 0 0 .5-10.98Z"/>
                <circle cx="16" cy="16" r="3" fill="#060914"/>
              </svg>
            </span>
            <span class="brand__text"><strong>Easycloud</strong><em>{{ $t('footer.brandSub') }}</em></span>
          </a>
          <p class="footer__desc">{{ $t('footer.desc') }}</p>
          <div class="footer__social">
            <a v-for="s in social" :key="s.label" href="#contact" :title="s.label" aria-label="social">{{ s.icon }}</a>
          </div>
        </div>

        <div class="footer__cols">
          <div v-for="col in columns" :key="col.title" class="footer__col">
            <h4>{{ col.title }}</h4>
            <a v-for="l in col.links" :key="l.label" :href="l.href">{{ l.label }}</a>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <span>{{ $t('footer.copyright') }}</span>
        <span class="footer__legal">
          <a v-for="item in legal" :key="item" href="#contact">{{ item }}</a>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      social: [
        { label: '微信', icon: '💬' },
        { label: '微博', icon: '📡' },
        { label: '邮箱', icon: '✉️' },
        { label: 'GitHub', icon: '🐙' }
      ]
    }
  },
  computed: {
    columns() { return this.$tm('footer.columns') },
    legal() { return this.$tm('footer.legal') }
  }
}
</script>

<style scoped>
.footer { border-top: 1px solid var(--ec-line); background: var(--ec-bg-soft); padding: 70px 0 30px; }
.footer__top { display: grid; grid-template-columns: 1.3fr 2fr; gap: 50px; padding-bottom: 44px; border-bottom: 1px solid var(--ec-line); }

.brand { display: inline-flex; align-items: center; gap: 11px; margin-bottom: 16px; }
.brand__text { display: flex; flex-direction: column; line-height: 1.05; }
.brand__text strong { font-size: 18px; font-weight: 800; }
.brand__text em { font-style: normal; font-size: 10.5px; color: var(--ec-text-mute); letter-spacing: 0.3em; }
.footer__desc { color: var(--ec-text-soft); font-size: 14px; max-width: 320px; margin-bottom: 20px; }
.footer__social { display: flex; gap: 10px; }
.footer__social a { width: 40px; height: 40px; display: grid; place-items: center; border-radius: 11px; background: var(--ec-card); border: 1px solid var(--ec-line); font-size: 17px; transition: all .25s ease; }
.footer__social a:hover { transform: translateY(-3px); border-color: rgba(255,153,0,.4); background: var(--ec-card-2); }

.footer__cols { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; }
.footer__col h4 { font-size: 15px; margin-bottom: 16px; color: var(--ec-text); }
.footer__col a { display: block; font-size: 14px; color: var(--ec-text-soft); margin-bottom: 11px; transition: color .2s ease; }
.footer__col a:hover { color: var(--ec-cyan); }

.footer__bottom { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding-top: 26px; font-size: 13px; color: var(--ec-text-mute); flex-wrap: wrap; }
.footer__legal { display: flex; gap: 22px; flex-wrap: wrap; }
.footer__legal a:hover { color: var(--ec-text-soft); }

@media (max-width: 860px) { .footer__top { grid-template-columns: 1fr; gap: 36px; } }
@media (max-width: 560px) { .footer__cols { grid-template-columns: repeat(2, 1fr); } }
</style>
